import { z } from 'zod';
import { coeProgramSchema, coeVendorSchema } from './coe.schema';

export const networkConfigSchema = z.object({
  /** TODO 21832: Add additional properties from network config serializer here */
  coeVendors: z.array(coeVendorSchema),
  coePrograms: z.array(coeProgramSchema),
});

export const networkSchema = z.object({
  slug: z.string(),
  /** TODO 21832: Add additional properties from network serializer here */
  config: networkConfigSchema,
});

export type NetworkConfig = z.infer<typeof networkConfigSchema>;
export type Network = z.infer<typeof networkSchema>;
